<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">엑셀 일괄업로드</span>
            <span class="txt">엑셀 일괄업로드가 필요한 데이터의 경우 여기에 올려주세요.</span>
        </div>

        <div class="com-tab">
            <button class="on">회원관리</button>
            <!-- <button>수업관리</button>
            <button>스케줄예약</button> -->
        </div>

        <div class="excel-info-content">
            <span class="tit">회원 데이터 파일업로드</span>
            <p class="txt">
                회원 데이터를 엑셀 파일로 일괄 업데이트 할 수 있습니다.
                <br />
                엑셀 파일 다운 받기 후 정해진 형식에 맞게 정보를 입력하신 후 파일 업로드 해주세요.
            </p>
            <div class="input-area">
                <div class="line">
                    <span class="tit">엑셀 파일 다운</span>
                    <div class="edit-box">
                        <button class="com-btn down" @click="excelDownload"><span>엑셀 형식 다운받기</span></button>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">데이터 올리기</span>
                    <div class="edit-box">
                        <input :value="fileName" class="design-input" readonly type="text" />
                        <b-form-file id="file1" plain @change="excelUpload"></b-form-file>
                        <label for="file1">엑셀파일 찾기</label>
                        <a class="com-btn red" href="#" @click="save">업로드</a>
                    </div>
                </div>
                <!-- <div class="line">
                    <span class="tit">데이터 입력</span>
                    <div class="edit-box">
                        <button class="com-btn gray">업로드한 데이터 적용하기</button>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import XLSX from 'xlsx';
import { excelUpload } from '@/assets/js/excelCommon';
import api from '@/assets/js/api';
import moment from 'moment';

export default {
    name: 'ExcelMember',
    props: {},
    computed: {
        centerId() {
            return this.$store.getters['auth/cId'];
        },
    },
    data() {
        return {
            workbook: '',
            fileName: '',
            failList: '',
        };
    },
    mounted() {},
    methods: {
        excelDownload() {
            const excelDownloadArreay = [
                [
                    '회원명',
                    '닉네임',
                    '성별',
                    '생년월일',
                    '연락처',
                    '현금영수증번호',
                    '이메일',
                    '이메일 동의',
                    '문자 동의',
                    'PUSH 동의',
                    '메모',
                ],
            ];
            const ws = XLSX.utils.aoa_to_sheet(excelDownloadArreay);

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '회원 일괄 업로드 양식');
            XLSX.writeFile(wb, '회원 일괄 업로드 양식.xlsx');
        },
        async excelUpload(event) {
            try {
                const file = event.target.files[0];
                this.fileName = file.name;
                const data = await excelUpload(file);
                this.workbook = XLSX.read(data, { type: 'array' });
            } catch (error) {
                for (let key in error) {
                    console.log('1', key, error[key]);
                }
                console.error(error);
            }
        },
        async save() {
            try {
                const params = [];
                this.failList = [];
                for (const key in this.workbook.Sheets) {
                    const sheet = this.workbook.Sheets[key];
                    const numberOfMember = XLSX.utils.sheet_to_json(this.workbook.Sheets[key]).length;

                    for (let i = 2; i <= numberOfMember + 1; i++) {
                        // console.log("생년월일", item['생년월일'].t, moment(item['생년월일']).format('YYYYMMDD'));

                        const param = {
                            name: sheet[`A${i}`] ? String(sheet[`A${i}`].v).trim() : '',
                            nickName: sheet[`B${i}`] ? String(sheet[`B${i}`].v).trim() : '',
                            sex: sheet[`C${i}`] ? (sheet[`C${i}`].v === '여' ? 'W' : 'M') : '',
                            birthday:
                                sheet[`D${i}`] && String(sheet[`D${i}`].v).trim()
                                    ? sheet[`D${i}`].t === 's'
                                        ? moment(String(sheet[`D${i}`].v).trim()).format('YYYYMMDD')
                                        : moment(sheet[`D${i}`].w).format('YYYYMMDD')
                                    : moment().format('YYYYMMDD'),
                            phone: sheet[`E${i}`] ? String(sheet[`E${i}`].v).replace(/-/g, '').trim() : '',
                            attendNo: sheet[`E${i}`] ? String(sheet[`E${i}`].v).replace(/-/g, '').trim().slice(-4) : '',
                            email: sheet[`F${i}`] ? String(sheet[`F${i}`].v).trim() : '',
                            texTelNo: sheet[`G${i}`] ? String(sheet[`G${i}`].v).replace(/-/g, '').trim() : '',
                            mktAgreeEmail: !sheet[`H${i}`] || String(sheet[`H${i}`].v).trim() !== 'N',
                            mktAgreeSms: !sheet[`I${i}`] || String(sheet[`I${i}`].v).trim() !== 'N',
                            mktAgreePush: !sheet[`J${i}`] || String(sheet[`J${i}`].v).trim() !== 'N',
                            memo: sheet[`K${i}`] ? String(sheet[`K${i}`].v).trim() : '',
                        };

                        if (
                            !param.name ||
                            !param.phone ||
                            param.phone.search(/[\u0000-\u002F]|[\u003A-\uFFFF]/) !== -1
                        ) {
                            this.failList.push(param);
                        } else {
                            params.push(param);
                        }
                    }
                }

                if (params.length > 0) {
                    this.resettingAtndNo(params);
                    this.postCenterCustomers(params);
                    alert('회원 업로드가 정상적으로 완료되었습니다.');
                } else {
                    alert('업로드할 회원 데이터가 존재하지 않습니다.');
                }
            } catch (error) {
                alert('회원 업로드 중에 오류가 발생하였습니다.');
                console.error(error);
            }
        },
        postCenterCustomers(params) {
            return api.post(`/admin/api/center/excel/${this.centerId}/save/customers`, params);
        },
        resettingAtndNo(params) {
            console.log(params);
            for (let i = 0; i < params.length; i++) {
                for (let j = 0; j < params.length; j++) {
                    if (i === j) continue;

                    if (params[i].attendNo === params[j].attendNo) {
                        while (true) {
                            const attendNo = String(Math.floor(Math.random() * 900000 + 100000));

                            if (params.findIndex((item) => item.attendNo === attendNo) === -1) {
                                params[i].attendNo = attendNo;
                                break;
                            }
                        }

                        break;
                    }
                }
            }
        },
    },
};
</script>
<style lang="scss"></style>
